import { Routes } from '@angular/router';
import { Shell } from './layouts/shell/shell';

export const routes: Routes = [
  {
    path: 'link/:code',
    loadComponent: () =>
      import('./features/deeplink/pages/link-shortlink-page').then((m) => m.LinkShortlinkPage),
  },
  {
    path: 'app',
    loadComponent: () =>
      import('./features/deeplink/pages/app-deeplink-page').then((m) => m.AppDeeplinkPage),
  },
  {
    path: 'onboarding',
    loadComponent: () =>
      import('./features/onboarding/pages/onboarding-page/onboarding-page').then(
        (m) => m.OnboardingPage,
      ),
  },
  {
    path: 'auth/login',
    loadComponent: () => import('./features/auth/pages/login/login-page').then((m) => m.LoginPage),
  },
  {
    path: '',
    component: Shell,
    children: [
      {
        path: 'home',
        loadComponent: () => import('./features/home/pages/home-page').then((m) => m.HomePage),
      },
      {
        path: 'missions',
        redirectTo: 'mission/list',
        pathMatch: 'full',
      },
      {
        path: 'mission',
        children: [
          {
            path: 'list',
            loadComponent: () =>
              import('./features/missions/pages/missions-page').then((m) => m.MissionsPage),
          },
          {
            path: 'details',
            loadComponent: () =>
              import('./features/missions/pages/mission-details/mission-details-page').then(
                (m) => m.MissionDetailsPage,
              ),
          },
        ],
      },
      {
        path: 'rewards',
        loadComponent: () =>
          import('./features/rewards/pages/rewards-page').then((m) => m.RewardsPage),
      },
      {
        path: 'my-rewards',
        loadComponent: () =>
          import('./features/rewards/pages/my-rewards-page').then((m) => m.MyRewardsPage),
      },
      {
        path: 'rewards/reward-details',
        loadComponent: () =>
          import('./features/rewards/pages/rewards-details/reward-details-page').then(
            (m) => m.RewardDetailsPage,
          ),
      },
      {
        path: 'tier-benefits',
        loadComponent: () =>
          import('./features/tier-benefits/pages/tier-benefits-page').then(
            (m) => m.TierBenefitsPage,
          ),
      },
      {
        path: 'family',
        loadComponent: () =>
          import('./features/family/pages/family-page').then((m) => m.FamilyPage),
      },
      {
        path: 'send-care',
        loadComponent: () => import('./features/send/pages/send-page').then((m) => m.SendPage),
      },
      {
        path: 'choose-recipient',
        loadComponent: () =>
          import('./features/send/pages/choose-recipient-page').then((m) => m.ChooseRecipientPage),
      },
      {
        path: 'refer-earn',
        loadComponent: () => import('./features/refer/pages/refer-page').then((m) => m.ReferPage),
      },
      {
        path: 'activity',
        loadComponent: () =>
          import('./features/activity/pages/activity-page').then((m) => m.ActivityPage),
      },
      {
        path: 'points-history',
        loadComponent: () =>
          import('./features/history/pages/points-history-page/points-history-page').then(
            (m) => m.PointsHistoryPage,
          ),
      },
      {
        path: 'coins-history',
        loadComponent: () =>
          import('./features/history/pages/coins-history-page/coins-history-page').then(
            (m) => m.CoinsHistoryPage,
          ),
      },
      {
        path: 'vip-tiers',
        loadComponent: () =>
          import('./features/vip-tiers/pages/vip-tiers-page/vip-tiers-page').then(
            (m) => m.VipTiersPage,
          ),
      },
      {
        path: 'account',
        loadComponent: () =>
          import('./features/account/pages/account-page').then((m) => m.AccountPage),
      },
      {
        path: 'faqs',
        loadComponent: () => import('./features/faqs/pages/faqs-page').then((m) => m.FaqsPage),
      },
      {
        path: 'privacy',
        loadComponent: () =>
          import('./features/legal/pages/privacy-page/privacy-page').then((m) => m.PrivacyPage),
      },
      {
        path: 'terms',
        loadComponent: () =>
          import('./features/legal/pages/terms-page/terms-page').then((m) => m.TermsPage),
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./features/profile/pages/profile-page').then((m) => m.ProfilePage),
      },
      {
        path: 'notifications/details',
        loadComponent: () =>
          import('./features/notifications/pages/notification-detail-page').then(
            (m) => m.NotificationDetailPage,
          ),
      },
      {
        path: 'notifications',
        loadComponent: () =>
          import('./features/notifications/pages/notifications-page').then(
            (m) => m.NotificationsPage,
          ),
      },
      {
        path: 'news',
        loadComponent: () =>
          import('./features/news/pages/news-events-page').then((m) => m.NewsEventsPage),
      },
      {
        path: 'news/:id',
        loadComponent: () =>
          import('./features/news/pages/news-article-page').then((m) => m.NewsArticlePage),
      },
      { path: '', redirectTo: 'home', pathMatch: 'full' },
    ],
  },
  { path: '**', redirectTo: 'home' },
];
